import { params } from '../localData'

export const PLAN_TYPES = {
  BASIC: 'BASIC_V2',
  PRO: 'PRO_V2',
  SMART: 'SMART',
  PREMIUM: 'PREMIUM',
}

export const PLAN_TYPES_DISPLAY = {
  BASIC_V2: 'Basic',
  PRO_V2: 'Pro',
  SMART: 'Smart',
  PREMIUM: 'Premium',
}

export const PlansPrices = {
  [PLAN_TYPES.BASIC]: '$0.00',
  [PLAN_TYPES.PRO]: '$9.00',
  [PLAN_TYPES.SMART]: '$20.00',
  [PLAN_TYPES.PREMIUM]: '$35.00',
}

export const CreditCardImagesClasses = {
  BASIC: 'credit-card-standard',
  PRO: 'credit-card-pro',
  SMART: 'credit-card-pro',
  PREMIUM: 'credit-card-premium',
}

export const UBORoles = {
  PARTNER: 'PARTNER',
  PARTNER_FULL_ACCESS: 'PARTNER_FULL_ACCESS',
}

export const INSTITUTION_IDS_MAP = {
  CHOICE: 'b0c290e9-67e5-4973-b3e5-8b2720088ee7',
  SUNRISE: 'b0c290e9-67e5-4973-b3e5-8b2720088ee8',
}

export const BANK_TYPES = {
  SUNRISE: 'SUNRISE',
  CHOICE: 'CHOICE',
}
export const BANK_TYPE_IDS_MAP = {
  [INSTITUTION_IDS_MAP.CHOICE]: 'CHOICE',
  [INSTITUTION_IDS_MAP.SUNRISE]: 'SUNRISE',
}

export const CUSTOM_MASK_TOKENS = {
  U: { pattern: /[a-zA-Z]/, transform: (val) => val.toLocaleUpperCase() },
  '#': { pattern: /\d/ },
  X: { pattern: /[0-9a-zA-Z ]/, transform: (val) => val.toLocaleUpperCase() }, // The space in the regex is here on purpose, don't remove it!
  '*': { pattern: /[0-9-()]/ },
  '!': { pattern: /[0-9a-zA-Z]/, transform: (val) => val.toLocaleUpperCase() },
}

export const MASK_TYPES = {
  digits: (num) => '#'.repeat(num),
  ALLOW_ALL: 'XXXXXXXXXXXXXXXXXXXX',
  ALPHA_NUM: 'U#U#U#',
  ALPHA_NUM_SPACE: `U#U #U#`,
  ALPHA_NUM_SPACE2: 'UU#U #UU',
  NUM_SPACE_ALPHA: '#### UU',
}

export const NATIONALITIES = {
  US: 'US',
  IN: 'IN',
  CN: 'CN',
  CA: 'CA',
  GB: 'GB',
  AU: 'AU',
  MX: 'MX',
  NL: 'NL',
  DE: 'DE',
  NZ: 'NZ',
  ES: 'ES',
  IL: 'IL',
}

export const DEFAULT_NATIONALITY = NATIONALITIES.US

export const COUNTRIES_MASK_MAP = {
  [NATIONALITIES.US]: MASK_TYPES.digits(5),
  [NATIONALITIES.IN]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.CN]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.CA]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.GB]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.AU]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.MX]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.NL]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.DE]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.NZ]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.ES]: MASK_TYPES.ALLOW_ALL,
  [NATIONALITIES.IL]: MASK_TYPES.ALLOW_ALL,
  DEFAULT: MASK_TYPES.ALLOW_ALL,
}

export const VALIDATION_REGEX = {
  EMAIL: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
}

export const ICON_SIZES = {
  LARGE: 'large',
  MID: 'mid',
}

export const IDENTITY_TABS = {
  US: 'us',
  NON_US: 'non_us',
}

export const MFA_TYPES = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
}

export const MFA_CLIENT_ID = process.env.VUE_APP_CLIENT_ID

export const MESSAGE_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
}

export const MESSAGE_TYPES_ICONS_MAP = {
  [MESSAGE_TYPES.SUCCESS]: 'GreenCheckmark',
  [MESSAGE_TYPES.ERROR]: 'WarningTriangle',
}

export const APY = '3.00'
export const APY_EFFECTIVE_DATE = 'January 1, 2025'

export const BUSINESS_TYPE_IDS = {
  CORP: 'corp',
  PARTNERSHIP: 'partner',
  LLC: 'llc',
  SOLE_PROP: 'sole',
}

export const INCOME_TYPES = {
  S_CORP: 'S_CORP',
  C_CORP: 'C_CORP',
  LLC: 'LLC',
  MMLLC: 'MMLLC',
  GENERAL_PARTNERSHIP: 'GENERAL_PARTNERSHIP',
  LLP: 'LLP',
}

export const BUSINESS_ADDRESS_TYPES = [
  INCOME_TYPES.LLC,
  INCOME_TYPES.MMLLC,
  INCOME_TYPES.LLP,
  INCOME_TYPES.C_CORP,
  INCOME_TYPES.S_CORP,
  INCOME_TYPES.GENERAL_PARTNERSHIP,
]
export const EXTRA_OWNERS_TYPES = [
  INCOME_TYPES.MMLLC,
  INCOME_TYPES.LLP,
  INCOME_TYPES.C_CORP,
  INCOME_TYPES.S_CORP,
  INCOME_TYPES.GENERAL_PARTNERSHIP,
]

export const MFA_INVALID_CODE_RESPONSE_CODES = [
  params.responseCodeEnums.MFA_CODE_IS_INVALID,
  '40040',
  '40041',
  '40042',
]

export const ID_TYPES = {
  PASSPORT: 'passport',
}

export const WEB_APP_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://app.lili.co'
    : 'https://integ-app.lili.co/'



// WEBPACK FOOTER //
// ./src/consts/index.js